import React, { useState, useEffect, useMemo } from 'react'
import Select from "react-select";
import data from '../data.json'

export const Cotizador = () => {

    const [selectedLote, setSelectedLote] = useState(null);
    const [selectedLoteOption, setSelectedLoteOption] = useState(null);
    const [selectedMensualidad, setSelectedMensualidad] = useState(6);
    const [selectedMensualidadOption, setSelectedMensualidadOption] = useState({ value: 6, label: "6 Meses" });

    const [enganche, setEnganche] = useState(0);
    const [mensualidades, setMensualidades] = useState(0);

    const lotesOptions = useMemo(() => data.lotes
      .filter((l) => l.status === "DISPONIBLE")
      .map((l) => ({
        value: l.lote,
        label: `Lote ${l.lote} - $${l.precioTotal.toLocaleString()} - ${l.m2}m² - ${l.vista}`,
      })), []);

    useEffect(() => {
      const handleSelectLote = (e) => {
        const loteNum = e.detail;
        const option = lotesOptions.find((o) => o.value === loteNum);
        if (option) {
          setSelectedLote(loteNum);
          setSelectedLoteOption(option);
        }
      };
      window.addEventListener('selectLote', handleSelectLote);
      return () => window.removeEventListener('selectLote', handleSelectLote);
    }, [lotesOptions]);
  
    const handleLoteChange = (selectedOption) => {
      setSelectedLote(selectedOption.value);
      setSelectedLoteOption(selectedOption);
    };
  
    const handleMensualidadChange = (selectedOptions) => {
      setSelectedMensualidad(selectedOptions.value);
      setSelectedMensualidadOption(selectedOptions);
    };
  
    useEffect(() => {
      if (selectedLote != null && selectedMensualidad != null) {
        const loteData = data.lotes.find((l) => l.lote === selectedLote);
        if (loteData) {
          setEnganche(loteData.enganche);
          const key = `mensualidad${selectedMensualidad}`;
          setMensualidades(loteData[key] ?? 0);
        }
      } else {
        setEnganche(0);
        setMensualidades(0);
      }
    }, [selectedLote, selectedMensualidad]);
    
    const customStyles = {
      option: (defaultStyles, state) => ({
        ...defaultStyles,
        color: state.isSelected ? "#213229" : "#213229",
        backgroundColor: state.isSelected ? "#fff" : "#fff",
      }),
  
      control: (defaultStyles) => ({
        ...defaultStyles,
        backgroundColor: "#213229",
        padding: "10px",
        border: "none",
        boxShadow: "none",
      }),
      singleValue: (defaultStyles) => ({ ...defaultStyles, color: "#fff" }),
    };
  return (
    <div id='cotizador-section' className='container-fluid cotizador-container'>
        <div className="overlay"></div>
        <div className='info-container'>
            <img src="/images/amenidades/4.svg" alt="" />
            <h2>Financiamiento directo con nosotros</h2>
            <a href="#contacto-section" className='button'>Precios desde $170,000</a>
            <h6>20% de enganche</h6>
            <p>Financiamiento de 6, 12, 24, 36 y <b><i>hasta 48 meses.</i></b></p>
        </div>
        <div className='cotizador'>
                <h3>Cotizador</h3>
                <form action="">
                    <div className="row justify-content-evenly">
                        <div className="col-xs-10 col-sm-10 col-md-5 col-lg-5">
                          <label>
                            Lotes
                          </label>
                        <Select options={lotesOptions} value={selectedLoteOption} onChange={handleLoteChange} styles={customStyles} placeholder="Elija un lote a cotizar"/>
                        </div>
                        <div className="col-xs-10 col-sm-10 col-md-5 col-lg-5">
                          <label>
                            Enganche - 20%
                          </label>
                        <input type="text" readOnly value={enganche ? `$${enganche.toLocaleString()}` : ''} placeholder="20% Enganche"/>
                        </div>
                        <div className="col-xs-10 col-sm-10 col-md-5 col-lg-5">
                          <label>
                            Mensualidades
                          </label>
                        <Select options={data.mensualidades} value={selectedMensualidadOption} onChange={handleMensualidadChange} styles={customStyles} placeholder="Mensualidades" />
                        </div>
                        <div className="col-xs-10 col-sm-10 col-md-5 col-lg-5">
                          <label>
                            Pago mensual
                          </label>
                        <input type="text" readOnly value={mensualidades ? `$${mensualidades.toLocaleString()}` : ''} placeholder="Mensualidades"/>
                        </div>
                    </div>
                </form>
                <span>Información meramente informativa y sujeto a cambio de precio sin previo aviso*</span>
            </div>
    </div>
  )
}
